import { NotifyHelper } from '../../../helpers/toast';
import { eChieuCaoCanNangDefine } from '../../action-types/dan-thuoc/IChieuCaoCanNangActionTypes';
import { generateActionForKey, generateActions } from '../generateActions';
export const chieuCaoCanNangActionts = {
    ...generateActions(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG"),
    ...generateActionForKey(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG",
        "SAVE_SUCCESS", () => { NotifyHelper.Success("Saved!") }),
    ...generateActionForKey(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG",
        "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG",
        "DELETE_SUCCESS", () => { NotifyHelper.Success("Deleted!") }),
    ...generateActionForKey(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG",
        "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG",
        "SEND_NOTIFY_SUCCESS", () => { NotifyHelper.Success("Sent!") }),
    ...generateActionForKey(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG",
        "SEND_NOTIFY_ERROR", (m) => { NotifyHelper.Error(m) }),
}